import client from '../../sanity_client'
import {urlFor} from '../../sanity_image'
import Nav from '@/components/Nav';
import Footer from '@/components/Footer';
import FeaturedPosts from '@/components/posts/FeaturedPosts';
import Banner from '@/components/PageBanner';
import {toHTML} from '@portabletext/to-html';
import {useEffect} from "react";
import groq from 'groq';
import ContactForm from '@/components/ContactForm';

export default function Partner({partner, pageContent, siteSettings}:any) {

  return (
    <>
      <Nav />
        <main className="row partner-page">
          <Banner bannerHeading={partner.title} bannerSubHeading={''} bannerImage={urlFor(pageContent[0].banner_image).width(1920).url()} />
          <section className="col-12 offset-sm-1 col-sm-5">
            <div className="row partner-details-row">
              <div className="col-12 col-sm-12 col-md-12 col-lg-6 partner-details-container">
                {partner.partner_one_image ?
                  <div className="partner-image-div" style={{backgroundImage:`url(${urlFor(partner.partner_one_image).width(700).url()})`}}></div>
                :
                  ''
                }
                <p className="partner-name">{partner.partner_one_name}</p>
                <p className="partner-title">{partner.partner_one_title}</p>
              </div>
              <div className="col-12 col-sm-12 col-md-12 col-lg-6 partner-details-container">
                {partner.partner_two_image ?
                  <div className="partner-image-div" style={{backgroundImage:`url(${urlFor(partner.partner_two_image).width(700).url()})`}}></div>
                  :
                  ''
                }
                <p className="partner-name">{partner.partner_two_name}</p>
                <p className="partner-title">{partner.partner_two_title}</p>         
              </div>
            </div>
          </section>
          <section className="col-12 col-sm-5 partner-description">
            <p className="partner-location">{partner.location}</p>
            <hr />
            <div dangerouslySetInnerHTML={{__html: toHTML(partner.description)}}>
              {/* */}
            </div>
          </section>
          <ContactForm adminEmails={siteSettings[0].admin_emails} />
        </main>
      <Footer />
    </>
  )
}
// @ts-ignore
export async function getServerSideProps(context) {
  // It's important to default the url_path so that it doesn't return "undefined"
  const { url_path = "" } = context.params
  const partner = await client.fetch(`*[_type == "partner" && url_path == $url_path][0]`, { url_path });
  const pageContent = await client.fetch(groq`*[_type == "partnersPage"]`);
  const siteSettings = await client.fetch(groq`*[_type == "siteSettings"]`);
  return {
    props: {
      partner: partner,
      pageContent: pageContent,
      siteSettings: siteSettings
    }
  }
}
